"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFromAPIRaw = parseFromAPIRaw;
exports.parseFromBranchSettingsRaw = parseFromBranchSettingsRaw;
exports.parseShiftSettingsToRaw = parseShiftSettingsToRaw;
exports.parseTimecardSettingsToRaw = parseTimecardSettingsToRaw;
exports.dateStringToKitchenTime = dateStringToKitchenTime;
const branchSettings_1 = require("../model/v1/branchSettings");
const common_1 = require("../common/common");
const common_2 = require("../js/common");
const timeZones_1 = __importDefault(require("../common/timeZones"));
const zeroDate_1 = require("../common/zeroDate");
// Parse from api package
function parseFromAPIRaw(rawData, timeZone = "Asia/Tokyo") {
    const defaultClosedDays = Array(7).fill(false);
    let shiftLockDate = undefined;
    let parsedAutoRest = undefined;
    if (rawData.shiftLockDate && !(0, common_2.isZeroDate)(new Date(rawData.shiftLockDate))) {
        shiftLockDate = (0, common_1.fromOplusTime)(new Date(rawData.shiftLockDate));
    }
    if (rawData.timecardAutoRests) {
        parsedAutoRest = parseAutoRest(rawData.timecardAutoRests);
    }
    const settingRequired = {
        timeZone: timeZone,
    };
    const settingsOptional = {
        staffCanViewSummary: rawData.canView,
        showWageRelatedForNonOwners: rawData.showWageRelatedForNonOwners,
        confirmShiftBorder: rawData.confirmShiftBorder,
        splitNightShift: rawData.splitNightShift,
        stackedRequest: rawData.stackedRequest,
        showRoles: rawData.showRoles,
        defaultView: rawData.defaultView,
        shiftInterval: rawData.shiftInterval,
        maxConsecutiveWorkdays: rawData.maxConsecutiveWorkdays,
        maxConsecutiveDaysOff: rawData.maxConsecutiveDaysOff,
        maxMonthLaborMinutes: (0, common_1.parseMaxMonthLaborMinutesRaw)(rawData.maxMonthLaborMinutes),
        weekStart: rawData.startOfWeek,
        monthStart: rawData.startOfMonth,
        yearStart: rawData.startOfYear,
        showRoleTimes: rawData.showRoleTimes,
        shiftWorkText: rawData.shiftWorkText,
        shiftOffText: rawData.shiftOffText,
        shiftPTOText: rawData.shiftPTOText,
        shiftHalfPTOText: rawData.shiftHalfPTOText,
        shiftStaffOffText: rawData.shiftStaffOffText,
        closedWeekdays: rawData.closedWeekdays || defaultClosedDays,
        summaryDayStart: rawData.dayViewFrom,
        summaryDayEnd: rawData.dayViewTo,
        shiftLockDate: shiftLockDate,
        shiftNotification: rawData.shiftNotification,
        isWorkCountInSummaryPage: rawData.isWorkCountInSummaryPage,
        isVacationCountInSummaryPage: rawData.isVacationCountInSummaryPage,
        isLaborInSummaryPage: rawData.isLaborInSummaryPage,
        isPTOCountInSummaryPage: rawData.isPTOCountInSummaryPage,
        isPlanMemoInSummaryPage: rawData.isPlanMemoInSummaryPage,
        isPlanNumInSummaryPage: rawData.isPlanNumInSummaryPage,
        isPlanNumEqInSummaryPage: rawData.isPlanNumEqInSummaryPage,
        isPlanRevenueInSummaryPage: rawData.isPlanRevenueInSummaryPage,
        isHidingPurposeInShiftModal: rawData.isHidingPurposeInShiftModal,
        isHidingFromInShiftModal: rawData.isHidingFromInShiftModal,
        isHidingToInShiftModal: rawData.isHidingToInShiftModal,
        isHidingMemoInShiftModal: rawData.isHidingMemoInShiftModal,
        isHidingRestInShiftModal: rawData.isHidingRestInShiftModal,
        isHidingCommentInputInShiftModal: rawData.isHidingCommentInputInShiftModal,
        isHidingTypeOInShiftModal: rawData.isHidingTypeOInShiftModal,
        isHidingTypeXInShiftModal: rawData.isHidingTypeXInShiftModal,
        isHidingTypePTOInShiftModal: rawData.isHidingTypePTOInShiftModal,
        isHidingTypeHalfPTOInShiftModal: rawData.isHidingTypeHalfPTOInShiftModal,
        isHidingTypePublicHolidayInShiftModal: rawData.isHidingTypePublicHolidayInShiftModal,
        isHidingTypeOtherHolidayInShiftModal: rawData.isHidingTypeOtherHolidayInShiftModal,
        isHidingRoleInStaffModal: rawData.isHidingRoleInStaffModal,
        autoConsec: rawData.autoConsec,
        autoConsecDaysOff: rawData.autoConsecDaysOff,
        staffLock: rawData.staffLock,
        staffLockedSummary: rawData.staffLockedSummary,
        transportSummary: rawData.transportSummary,
        memoSummary: rawData.memoSummary,
        dwsSort: rawData.dwsSort,
        requestOff: rawData.requestOff,
        roleRequestOff: rawData.roleRequestOff,
        hideTimeLess: rawData.hideTimeLess,
        hideLiveChat: rawData.hideLiveChat,
        enableKingOfTime: rawData.KOT,
        enableMoneyForward: rawData.MF,
        enableSmartHR: rawData.SmartHR,
        enableMinajin: rawData.Minajin,
        enablePathosLogos: rawData.PathosLogos,
        enableXronos: rawData.Xronos,
        staffNoBoard: rawData.staffNoBoard,
        timecardRoundFrom: rawData.timecardRoundFrom,
        timecardRoundTo: rawData.timecardRoundTo,
        timecardRoundRestFrom: rawData.timecardRoundRestFrom,
        timecardRoundRestTo: rawData.timecardRoundRestTo,
        timecardAutoRests: parsedAutoRest,
        isHidingRestTimecard: rawData.isHidingRestTimecard,
        freePunch: rawData.freePunch,
        punchLocation: rawData.punchLocation,
        branchBasedPunch: rawData.branchBasedPunch,
        enableHideTimecard: rawData.enableHideTimecard,
        enableOfflineKiosk: rawData.enableOfflineKiosk,
        isHidingTimeCardEdit: rawData.isHidingTimeCardEdit,
        timecardAutoDelete: rawData.timecardAutoDelete,
        timecardCeilingFrom: rawData.timecardCeilingFrom,
        timecardFloorTo: rawData.timecardFloorTo,
        overtimeWarning: rawData.overtimeWarning,
        overtimeWarningMonthly: rawData.overtimeWarningMonthly,
        overtimeStartTime: rawData.overtimeStartTime,
        overtimeStartTimeHours: rawData.overtimeStartTimeHours,
        showOvertimeStartTime: rawData.showOvertimeStartTime,
        overtimeAlertStartDayEnabled: rawData.overtimeAlertStartDayEnabled,
        overtimeAlertStartDay: rawData.overtimeAlertStartDay,
        ccBizWorkplaceCode: rawData.ccBizWorkplaceCode,
        apiRemoveExisting: rawData.apiRemoveExisting,
        minVacationWeekly: rawData.minVacationWeekly,
        minVacationMonthly: rawData.minVacationMonthly,
        maxWorkDaysPerMonth: rawData.maxWorkDaysPerMonth,
        maxWorkDaysPerWeek: rawData.maxWorkDaysPerWeek,
        maxVacationMonthly: rawData.maxVacationMonthly,
        maxWeekLaborMinutes: (0, common_1.parseMaxMonthLaborMinutesRaw)(rawData.maxWeekLaborMinutes),
    };
    const settings = new branchSettings_1.BranchSettings(settingRequired, settingsOptional);
    return settings;
}
function parseFromBranchSettingsRaw(rawSettings) {
    const settings = {
        shiftStaffOffText: rawSettings.ShiftStaffOffText || "",
        roleRequestOff: rawSettings.RoleRequestOff || false,
        shiftWorkText: rawSettings.ShiftWorkText || "",
        requestOff: rawSettings.RequestOff || false,
        shiftOffText: rawSettings.ShiftOffText || "",
        shiftPTOText: rawSettings.ShiftPTOText || "",
        shiftHalfPTOText: rawSettings.ShiftHalfPTOText || "",
        showRoleTimes: rawSettings.ShowRoleTimes || 0,
        splitNightShift: rawSettings.SplitNightShift || false,
    };
    return settings;
}
function parseShiftSettingsToRaw(branch, settings) {
    // Shift Raw
    const shiftNotification = (0, common_1.durationToKitchenTime)(settings.shiftNotification, "minutes");
    const shiftInterval = (0, common_1.durationToKitchenTime)(settings.shiftInterval, "minutes");
    let shiftLockDate = zeroDate_1.zeroDate.full; // zero date
    if (settings.shiftLockDate) {
        shiftLockDate = (0, common_1.yearMonthDateString)(settings.shiftLockDate, timeZones_1.default.ASIA_TOKYO);
    }
    const shiftRaw = {
        id: branch.getOriginalId(),
        name: branch.getBranchName(),
    };
    if (settings.autoConsec !== undefined) {
        shiftRaw.autoConsec = settings.autoConsec;
    }
    if (settings.autoConsecDaysOff !== undefined) {
        shiftRaw.autoConsecDaysOff = settings.autoConsecDaysOff;
    }
    if (settings.staffCanViewSummary !== undefined) {
        shiftRaw.canView = settings.staffCanViewSummary;
    }
    if (settings.confirmShiftBorder !== undefined) {
        shiftRaw.confirmShiftBorder = settings.confirmShiftBorder;
    }
    if (settings.closedWeekdays !== undefined) {
        shiftRaw.closedWeekdays = settings.closedWeekdays;
    }
    if (settings.summaryDayStart !== undefined) {
        shiftRaw.dayViewFrom = settings.summaryDayStart;
    }
    if (settings.summaryDayEnd !== undefined) {
        shiftRaw.dayViewTo = settings.summaryDayEnd;
    }
    if (settings.defaultView !== undefined) {
        shiftRaw.defaultView = settings.defaultView;
    }
    if (settings.dwsSort !== undefined) {
        shiftRaw.dwsSort = settings.dwsSort;
    }
    if (settings.hideLiveChat !== undefined) {
        shiftRaw.hideLiveChat = settings.hideLiveChat;
    }
    if (settings.hideTimeLess !== undefined) {
        shiftRaw.hideTimeLess = settings.hideTimeLess;
    }
    if (settings.isHidingCommentInputInShiftModal !== undefined) {
        shiftRaw.isHidingCommentInputInShiftModal = settings.isHidingCommentInputInShiftModal;
    }
    if (settings.isHidingFromInShiftModal !== undefined) {
        shiftRaw.isHidingFromInShiftModal = settings.isHidingFromInShiftModal;
    }
    if (settings.isHidingPurposeInShiftModal !== undefined) {
        shiftRaw.isHidingPurposeInShiftModal = settings.isHidingPurposeInShiftModal;
    }
    if (settings.isHidingRestInShiftModal !== undefined) {
        shiftRaw.isHidingRestInShiftModal = settings.isHidingRestInShiftModal;
    }
    if (settings.isHidingRoleInStaffModal !== undefined) {
        shiftRaw.isHidingRoleInStaffModal = settings.isHidingRoleInStaffModal;
    }
    if (settings.isHidingToInShiftModal !== undefined) {
        shiftRaw.isHidingToInShiftModal = settings.isHidingToInShiftModal;
    }
    if (settings.isHidingMemoInShiftModal !== undefined) {
        shiftRaw.isHidingMemoInShiftModal = settings.isHidingMemoInShiftModal;
    }
    if (settings.isHidingTypeHalfPTOInShiftModal !== undefined) {
        shiftRaw.isHidingTypeHalfPTOInShiftModal = settings.isHidingTypeHalfPTOInShiftModal;
    }
    if (settings.isHidingTypeOInShiftModal !== undefined) {
        shiftRaw.isHidingTypeOInShiftModal = settings.isHidingTypeOInShiftModal;
    }
    if (settings.isHidingTypeOtherHolidayInShiftModal !== undefined) {
        shiftRaw.isHidingTypeOtherHolidayInShiftModal = settings.isHidingTypeOtherHolidayInShiftModal;
    }
    if (settings.isHidingTypePTOInShiftModal !== undefined) {
        shiftRaw.isHidingTypePTOInShiftModal = settings.isHidingTypePTOInShiftModal;
    }
    if (settings.isHidingTypePublicHolidayInShiftModal !== undefined) {
        shiftRaw.isHidingTypePublicHolidayInShiftModal = settings.isHidingTypePublicHolidayInShiftModal;
    }
    if (settings.isHidingTypeXInShiftModal !== undefined) {
        shiftRaw.isHidingTypeXInShiftModal = settings.isHidingTypeXInShiftModal;
    }
    if (settings.isLaborInSummaryPage !== undefined) {
        shiftRaw.isLaborInSummaryPage = settings.isLaborInSummaryPage;
    }
    if (settings.isPTOCountInSummaryPage !== undefined) {
        shiftRaw.isPTOCountInSummaryPage = settings.isPTOCountInSummaryPage;
    }
    if (settings.isPlanMemoInSummaryPage !== undefined) {
        shiftRaw.isPlanMemoInSummaryPage = settings.isPlanMemoInSummaryPage;
    }
    if (settings.isPlanNumEqInSummaryPage !== undefined) {
        shiftRaw.isPlanNumEqInSummaryPage = settings.isPlanNumEqInSummaryPage;
    }
    if (settings.isPlanNumInSummaryPage !== undefined) {
        shiftRaw.isPlanNumInSummaryPage = settings.isPlanNumInSummaryPage;
    }
    if (settings.isPlanRevenueInSummaryPage !== undefined) {
        shiftRaw.isPlanRevenueInSummaryPage = settings.isPlanRevenueInSummaryPage;
    }
    if (settings.isVacationCountInSummaryPage !== undefined) {
        shiftRaw.isVacationCountInSummaryPage = settings.isVacationCountInSummaryPage;
    }
    if (settings.isWorkCountInSummaryPage !== undefined) {
        shiftRaw.isWorkCountInSummaryPage = settings.isWorkCountInSummaryPage;
    }
    if (settings.maxConsecutiveWorkdays !== undefined) {
        shiftRaw.maxConsecutiveWorkdays = settings.maxConsecutiveWorkdays;
    }
    if (settings.maxConsecutiveDaysOff !== undefined) {
        shiftRaw.maxConsecutiveDaysOff = settings.maxConsecutiveDaysOff;
    }
    if (settings.maxMonthLaborMinutes !== undefined) {
        shiftRaw.maxMonthLaborMinutes = settings.maxMonthLaborMinutes;
    }
    if (settings.memoSummary !== undefined) {
        shiftRaw.memoSummary = settings.memoSummary;
    }
    if (settings.requestOff !== undefined) {
        shiftRaw.requestOff = settings.requestOff;
    }
    if (settings.roleRequestOff !== undefined) {
        shiftRaw.roleRequestOff = settings.roleRequestOff;
    }
    if (shiftInterval !== undefined) {
        shiftRaw.shiftInterval = shiftInterval;
    }
    if (shiftLockDate !== undefined) {
        shiftRaw.shiftLockDate = shiftLockDate;
    }
    if (shiftNotification !== undefined) {
        shiftRaw.shiftNotification = shiftNotification;
    }
    if (settings.shiftOffText !== undefined) {
        shiftRaw.shiftOffText = settings.shiftOffText;
    }
    if (settings.shiftPTOText !== undefined) {
        shiftRaw.shiftPTOText = settings.shiftPTOText;
    }
    if (settings.shiftStaffOffText !== undefined) {
        shiftRaw.shiftStaffOffText = settings.shiftStaffOffText;
    }
    if (settings.shiftWorkText !== undefined) {
        shiftRaw.shiftWorkText = settings.shiftWorkText;
    }
    if (settings.shiftHalfPTOText !== undefined) {
        shiftRaw.shiftHalfPTOText = settings.shiftHalfPTOText;
    }
    if (settings.showRoleTimes !== undefined) {
        shiftRaw.showRoleTimes = settings.showRoleTimes;
    }
    if (settings.showRoles !== undefined) {
        shiftRaw.showRoles = settings.showRoles;
    }
    if (settings.splitNightShift !== undefined) {
        shiftRaw.splitNightShift = settings.splitNightShift;
    }
    if (settings.stackedRequest !== undefined) {
        shiftRaw.stackedRequest = settings.stackedRequest;
    }
    if (settings.staffLock !== undefined) {
        shiftRaw.staffLock = settings.staffLock;
    }
    if (settings.staffLockedSummary !== undefined) {
        shiftRaw.staffLockedSummary = settings.staffLockedSummary;
    }
    if (settings.staffNoBoard !== undefined) {
        shiftRaw.staffNoBoard = settings.staffNoBoard;
    }
    if (settings.monthStart !== undefined) {
        shiftRaw.startOfMonth = settings.monthStart;
    }
    if (settings.weekStart !== undefined) {
        shiftRaw.startOfWeek = settings.weekStart;
    }
    if (settings.yearStart !== undefined) {
        shiftRaw.startOfYear = settings.yearStart;
    }
    if (settings.transportSummary !== undefined) {
        shiftRaw.transportSummary = settings.transportSummary;
    }
    if (settings.minVacationWeekly !== undefined) {
        shiftRaw.minVacationWeekly = settings.minVacationWeekly;
    }
    if (settings.minVacationMonthly !== undefined) {
        shiftRaw.minVacationMonthly = settings.minVacationMonthly;
    }
    if (settings.maxWorkDaysPerMonth !== undefined) {
        shiftRaw.maxWorkDaysPerMonth = settings.maxWorkDaysPerMonth;
    }
    if (settings.maxWorkDaysPerWeek !== undefined) {
        shiftRaw.maxWorkDaysPerWeek = settings.maxWorkDaysPerWeek;
    }
    if (settings.maxVacationMonthly !== undefined) {
        shiftRaw.maxVacationMonthly = settings.maxVacationMonthly;
    }
    if (settings.maxWeekLaborMinutes !== undefined) {
        shiftRaw.maxWeekLaborMinutes = settings.maxWeekLaborMinutes;
    }
    if (settings.overtimeStartTime !== undefined) {
        shiftRaw.overtimeStartTime = settings.overtimeStartTime;
    }
    if (settings.overtimeStartTimeHours !== undefined) {
        shiftRaw.overtimeStartTimeHours = settings.overtimeStartTimeHours;
    }
    if (settings.showOvertimeStartTime !== undefined) {
        shiftRaw.showOvertimeStartTime = settings.showOvertimeStartTime;
    }
    if (settings.showWageRelatedForNonOwners !== undefined) {
        shiftRaw.showWageRelatedForNonOwners = settings.showWageRelatedForNonOwners;
    }
    return {
        shift: shiftRaw,
    };
}
function parseTimecardSettingsToRaw(branch, settings) {
    // TODO: type checks
    const overtimeWarning = (0, common_1.durationToKitchenTime)(settings.overtimeWarning, "minutes");
    const overtimeWarningMonthly = (0, common_1.durationToKitchenTime)(settings.overtimeWarningMonthly, "minutes");
    const autoRests = parseAutoRestToRaw(settings.timecardAutoRests);
    // Timecard Raw
    const timecardRaw = {
        id: branch.getOriginalId(),
        name: branch.getBranchName(),
    };
    if (settings.timecardRoundFrom !== undefined) {
        timecardRaw.timecardRoundFrom = settings.timecardRoundFrom;
    }
    if (settings.timecardRoundTo !== undefined) {
        timecardRaw.timecardRoundTo = settings.timecardRoundTo;
    }
    if (settings.timecardRoundRestFrom !== undefined) {
        timecardRaw.timecardRoundRestFrom = settings.timecardRoundRestFrom;
    }
    if (settings.timecardRoundRestTo !== undefined) {
        timecardRaw.timecardRoundRestTo = settings.timecardRoundRestTo;
    }
    if (autoRests !== undefined) {
        timecardRaw.timecardAutoRests = autoRests;
    }
    if (settings.isHidingRestTimecard !== undefined) {
        timecardRaw.isHidingRestTimecard = settings.isHidingRestTimecard;
    }
    if (settings.freePunch !== undefined) {
        timecardRaw.freePunch = settings.freePunch;
    }
    if (settings.punchLocation !== undefined) {
        timecardRaw.punchLocation = settings.punchLocation;
    }
    if (settings.branchBasedPunch !== undefined) {
        timecardRaw.branchBasedPunch = settings.branchBasedPunch;
    }
    if (settings.enableHideTimecard !== undefined) {
        timecardRaw.enableHideTimecard = settings.enableHideTimecard;
    }
    if (settings.enableOfflineKiosk !== undefined) {
        timecardRaw.enableOfflineKiosk = settings.enableOfflineKiosk;
    }
    if (settings.isHidingTimeCardEdit !== undefined) {
        timecardRaw.isHidingTimeCardEdit = settings.isHidingTimeCardEdit;
    }
    if (settings.timecardAutoDelete !== undefined) {
        timecardRaw.timecardAutoDelete = settings.timecardAutoDelete;
    }
    if (settings.timecardCeilingFrom !== undefined) {
        timecardRaw.timecardCeilingFrom = settings.timecardCeilingFrom;
    }
    if (settings.timecardFloorTo !== undefined) {
        timecardRaw.timecardFloorTo = settings.timecardFloorTo;
    }
    if (overtimeWarning !== undefined) {
        timecardRaw.overtimeWarning = overtimeWarning;
    }
    if (overtimeWarningMonthly !== undefined) {
        timecardRaw.overtimeWarningMonthly = overtimeWarningMonthly;
    }
    if (settings.overtimeAlertStartDayEnabled !== undefined) {
        timecardRaw.overtimeAlertStartDayEnabled = settings.overtimeAlertStartDayEnabled;
    }
    if (settings.overtimeAlertStartDay !== undefined) {
        timecardRaw.overtimeAlertStartDay = settings.overtimeAlertStartDay;
    }
    return {
        timecard: timecardRaw
    };
}
function parseAutoRestToRaw(autoRests) {
    const autoRestStrings = [];
    if (autoRests) {
        autoRests.forEach(s => {
            const textString = `${s.labor}##${s.value}`;
            autoRestStrings.push(textString);
        });
    }
    return autoRestStrings.join(",");
}
function dateStringToKitchenTime(dateStr) {
    let str = "";
    if (dateStr) {
        const date = new Date(dateStr);
        const hours = date.getUTCHours();
        const minutes = date.getUTCMinutes();
        str = `${(0, common_2.addZeroPlaceholders)(hours)}:${(0, common_2.addZeroPlaceholders)(minutes)}`;
    }
    return str;
}
function parseAutoRest(rawAutoRests) {
    const autoRest = [];
    if (rawAutoRests) {
        rawAutoRests.forEach(r => {
            autoRest.push({
                labor: dateStringToKitchenTime(r),
                value: calcAutoRests(r),
            });
        });
    }
    return autoRest;
}
// AutoRest consist of `Labor` and `Rest` time, the BE just returns 1 date, which consist of nanonseconds, this (nanosecond * 1,000,000,000) is the `Rest` part
function getNanosecondsFromDateString(dateString) {
    const fractionalPartMatch = dateString.match(/\.(\d+)Z$/);
    let mseconds = 0;
    if (fractionalPartMatch) {
        const fractionalPart = fractionalPartMatch[0];
        mseconds = parseFloat(fractionalPart) * 1000000;
    }
    return mseconds * 1000;
}
function calcAutoRests(dateStr) {
    const ns = getNanosecondsFromDateString(dateStr);
    return (0, common_1.durationToKitchenTime)(ns / 1000, "minutes");
}
